import styled from "@emotion/styled";
export const StyledEmptyStateComponent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 72px;
    align-items: center;

    .asset-inner {
        width: fit-content;

        img {
            width: 220px;
        }
    }
`;
